import React from 'react'

import Grid from '../../../../components/Grid'
import LegalAreaItem from './LegalAreaItem'
import { items as _items } from './data'

import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

const LegalArea: React.FC<{
  locale: ELocale
  copy: string
  items?: TItem[]
}> = (props) => {
  const { locale, copy, items = _items } = props

  return (
    <Grid.Container className="mt-48 mb-24">
      <Grid.Row as="ul" className="justify-center flex-no-wrap">
        {items.map((item: TItem) => (
          <LegalAreaItem key={item.label} item={item} locale={locale} />
        ))}
      </Grid.Row>
      <p className="text-12 text-center mt-16">{copy}</p>
    </Grid.Container>
  )
}

export { LegalArea as default }
